import type { ReadingActivityCell } from '@/features/library/api/library.api.js';
import { useReadingActivity } from '@/features/library/hooks/useReadingActivity.js';

const TOTAL_CELLS = 52 * 7;

const EMPTY_CELLS: ReadonlyArray<ReadingActivityCell> = Array.from(
  { length: TOTAL_CELLS },
  (_, i) => ({
    date: `placeholder-${i}`,
    level: 0,
  }),
);

export function HeatmapCard(): JSX.Element {
  const { data, isLoading } = useReadingActivity();

  const cells = data?.cells ?? EMPTY_CELLS;
  const activeDays = data?.activeDays ?? 0;

  return (
    <section className="heatmap-card">
      <div className="mb-4 flex items-baseline justify-between gap-2">
        <div>
          <p className="font-serif text-base font-semibold text-brown">
            📅 Ton année de lecture
          </p>
          <p className="font-script text-sm text-brown-soft">
            {isLoading
              ? 'Chargement…'
              : `${activeDays} jour${activeDays > 1 ? 's' : ''} actif${
                  activeDays > 1 ? 's' : ''
                } cette année`}
          </p>
        </div>
      </div>
      <div className="heatmap-grid">
        {cells.map((cell) => (
          <span
            key={cell.date}
            className={`heatmap-cell${cell.level > 0 ? ` l${cell.level}` : ''}`}
            title={cell.date.startsWith('placeholder-') ? undefined : cell.date}
            aria-hidden
          />
        ))}
      </div>
      <div className="mt-3 flex items-center justify-end gap-1 text-[11px] text-brown-light">
        <span>—</span>
        <span className="heatmap-cell h-3 w-3" />
        <span className="heatmap-cell l1 h-3 w-3" />
        <span className="heatmap-cell l2 h-3 w-3" />
        <span className="heatmap-cell l3 h-3 w-3" />
        <span className="heatmap-cell l4 h-3 w-3" />
        <span>+</span>
      </div>
    </section>
  );
}
